import { render } from "./ItemMediaComponent.vue?vue&type=template&id=3bedc24a&scoped=true&ts=true"
import script from "./ItemMediaComponent.vue?vue&type=script&lang=ts"
export * from "./ItemMediaComponent.vue?vue&type=script&lang=ts"

import "./ItemMediaComponent.vue?vue&type=style&index=0&id=3bedc24a&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bedc24a"]])

export default __exports__